module.exports = __webpack_public_path__ + "static/media/Delete.727e026c.svg";